module.exports = __webpack_public_path__ + "static/media/pg_gif.83ae344a.gif";